import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataPromotion } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_PROMOTION = defineMasterdataEntity<MasterdataPromotion>({
  name: 'promotion',
  responseKey: 'promotions',
  displayWith: (p) => keyName(p.key, p.name),
  secondaryWith: (p) => p.name2,
  icon: 'fa-regular fa-tags',
  title: 'Aktionssuche',
  label: 'Aktion',
  placeholder: 'Aktion suchen...',
  columns: [
    {
      label: 'Aktion',
      type: 'entity',
      icon: 'fa-regular fa-tags',
      value: (p) => keyName(p.key, p.name),
      secondary: (p) => p.name2,
    },
    { label: 'Schlüssel', value: (p) => p.key },
    { label: 'Bezeichnung', value: (p) => p.name },
    { label: 'Bezeichnung 2', value: (p) => p.name2 },
    { label: 'Status', value: (p) => p.status?.name ?? null },
    { label: 'Gültig ab (VK)', value: (p) => p.validFrom },
    { label: 'Gültig bis (VK)', value: (p) => p.validTo },
    { label: 'Gültig ab (EK)', value: (p) => p.purchaseValidFrom },
    { label: 'Gültig bis (EK)', value: (p) => p.purchaseValidTo },
    { label: 'Verkaufsorganisationen', value: (p) => p.salesOrganizations?.join(', ') ?? null },
  ],
});
